<template>
  <div class="table-list">
    <template v-if="tableItem.hide_title == '0'">
      <div class="table-list-title" v-if="tableItem.type == 0">
        <i class="iconfont">&#xe66a;</i>{{tableItem.title}}
      </div>
      <div class="top-title" v-else>
        <div class="font">{{tableItem.title}}</div>
      </div>
    </template>
    <div class="table-list-summary" v-html="tableItem.summary"></div>
    <div class="table-list-content">
      <Table :columns="listColumns" :data="listData" :class="{'toplist': tableItem.type == 1}"></Table>
    </div>
    <p class="tip">数据来源：<template v-if="tableItem.src">{{tableItem.src}}</template><template v-else>动脉橙产业智库</template></p>
    <div class="spa">
      <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="handleShare(paramsUid)" @on-popper-hide="handleShareHide">
        <i class="iconfont">&#xe641;</i>
        <div slot="content" class="share_cnt clear">
          <div class="share_img"></div>
          <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
        </div>
      </Poptip>
    </div>
  </div>
</template>
<script>
export default {
  props: ['tableItem', 'paramsUid'],
  data() {
    return {
      listColumns: [],
      listData: [],
    }
  },
  methods: {
    goEntityDetail(uid, type) {
      if (type == 0) {
        const { href } = this.$router.resolve({ name: 'CompanyDetail', params: { uid: uid } })
        window.open(href, '_blank')
      } else if (type == 1) {
        const { href } = this.$router.resolve({ name: 'OrgDetail', params: { uid: uid } })
        window.open(href, '_blank')
      } else if (type == 2) {
        const { href } = this.$router.resolve({ name: 'PeoDetail', params: { uid: uid } })
        window.open(href, '_blank')
      } else if (type == 3) {
        const { href } = this.$router.resolve({ name: 'HospitalDetail', params: { uid: uid } })
        window.open(href, '_blank')
      }
    },
    handleShare(theme_uid) {
      let share_link =
        window.location.protocol +
        '//' +
        window.location.host +
        '/mindex/shareTable?theme_uid=' +
        theme_uid +
        '&table_id=' +
        this.tableItem.id
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link,
      })
    },
    handleShareHide() {
      $('.share_img').html('')
    },
    goPolicy(uid) {
      const { href } = this.$router.resolve({ name: 'PolicyDetail', params: { uid: uid } })
      window.open(href, '_blank')
    },
  },
  created() {
    let table_wid

    if (this.tableItem.table_data.length) {
      let tarr = this.tableItem.table_data[0].table_content.filter((b) => b.meta == '序号')
      if (tarr.length || this.tableItem.type == 1) {
        if (tarr.length == 0) {
          table_wid = 648
          this.listColumns.push({
            title: '排名',
            width: 50,
            align: 'center',
            className: 'num',
            render: (h, params) => {
              let cls = ['dec-num', 'dec-num-' + (params.index + 1)]
              return h('div', { class: cls }, params.index + 1)
            },
          })
        } else {
          table_wid = 698 - 50 * tarr.length
        }
      } else {
        table_wid = 698
      }

      this.tableItem.table_data.map((a, index) => {
        let obj = {}
        let wid = 0
        if (index === 0) {
          a.table_content.map((b) => {
            if (b.meta !== '序号') wid += b.col_width
          })
        }
        a.table_content.map((b, e_id) => {
          if (b.meta === '实体' || b.meta === '政策') {
            obj['content_name' + e_id] = b.element_value
            obj['content_uid' + e_id] = b.content_uid
            obj['content_type' + e_id] = b.content_type
          } else {
            obj['content_name' + e_id] = b.element_value
          }
          if (b.meta === '政策') {
            obj['policy_status' + e_id] = b.policy_status
          }
          if (index === 0 && b.meta === '实体') {
            this.listColumns.push({
              title: b.element_name,
              width: (b.col_width / wid) * table_wid,
              render: (h, params) => {
                if (params['row']['content_uid' + e_id]) {
                  return h('div', { class: { 'dec-clamp': true } }, [
                    h(
                      'a',
                      {
                        on: {
                          click: () => {
                            this.goEntityDetail(
                              params['row']['content_uid' + e_id],
                              params['row']['content_type' + e_id]
                            )
                          },
                        },
                      },
                      params['row']['content_name' + e_id]
                    ),
                  ])
                } else {
                  return h(
                    'div',
                    { class: { 'dec-clamp': true } },
                    params['row']['content_name' + e_id]
                  )
                }
              },
            })
          } else if (index === 0 && b.meta === '政策') {
            this.listColumns.push({
              title: b.element_name,
              width: (b.col_width / wid) * table_wid,
              render: (h, params) => {
                if (
                  params['row']['content_uid' + e_id] &&
                  params['row']['policy_status' + e_id] == 1
                ) {
                  return h('div', { class: { 'dec-clamp': true } }, [
                    h(
                      'a',
                      {
                        on: {
                          click: () => {
                            this.goPolicy(params['row']['content_uid' + e_id])
                          },
                        },
                      },
                      params['row']['content_name' + e_id]
                    ),
                  ])
                } else {
                  return h(
                    'div',
                    { class: { 'dec-clamp': true } },
                    params['row']['content_name' + e_id]
                  )
                }
              },
            })
          } else if (index === 0 && b.meta === '文本') {
            this.listColumns.push({
              title: b.element_name,
              width: (b.col_width / wid) * table_wid,
              render: (h, params) => {
                return h(
                  'div',
                  { class: { 'dec-clamp': true } },
                  params['row']['content_name' + e_id]
                )
              },
            })
          } else if (index === 0 && b.meta === '序号') {
            this.listColumns.push({
              title: b.element_name,
              width: 50,
              className: 'num',
              align: 'center',
              render: (h, params) => {
                let cls = ['dec-num', 'dec-num-' + params['row']['content_name' + e_id]]
                return h('div', { class: cls }, params['row']['content_name' + e_id])
              },
            })
          }
        })
        this.listData.push(obj)
      })
    }
  },
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.table-list
  position relative
  .top-title
    display flex
    justify-content center
    height 56px
    background url('~pic/topfontbg.png') top center no-repeat
    .font
      font-size 18px
      line-height 1
      padding-top 20px
      color #404877
      position relative
      &:before, &:after
        content ''
        position absolute
        width 74px
        height 14px
        background url('~pic/topfontlt.png') center no-repeat
        top 22px
        left -84px
      &:after
        left auto
        right -84px
        background url('~pic/topfontrt.png') center no-repeat
  &-title
    font-size 16px
    font-weight 600
    commonColor(#ffffff, #333333)
    margin-bottom 10px
    line-height 22px
    i
      color #FC9C7C
      margin-right 15px
  &-summary
    commonColor(#BCBDC1, #666666)
    font-size 14px
    line-height 22px
    margin-top -3px
    margin-bottom 7px
  &-content
    commonBgImg('~pic/watermark-white.png', '~pic/watermark-gray.png')
    >>> .ivu-table
      background transparent !important
      table
        border 1px solid #EEEEEE
      .ivu-table-body
        table
          border-top 0 !important
      .ivu-table-header
        background transparent !important
        table
          border-bottom 0 !important
      th
        line-height 22px
        padding 10px 0
        border-left 1px solid #EEEEEE
        background-color rgba(255, 136, 36, 0.2)
      td
        position relative
        border-left 1px solid
        commonBorderColor(#40444F, #EEEEEE)
        border-bottom 0
        transition all 0.2s
        padding 0
        commonColor(#FFF, #333)
        a
          commonColor(#FFF, #333)
          &:hover
            color rgb(255, 136, 36) !important
        .dec-num
          font-size 18px
          font-weight bold
          color #ffcda3
      .num
        .ivu-table-cell
          padding 0 !important
      .ivu-table-row-hover
        td
          border-color #FFCDA3 !important
          background-color #FFCDA3 !important
          color #fff
          .dec-num
            color #fff !important
          a
            color #fff
          &.num
            background-color #FA5A00 !important
      .ivu-table-tbody
        .ivu-table-row:nth-of-type(even)
          commonBgColor(rgba(128, 144, 201, 0.2), rgba(255, 136, 36, 0.2))
          td
            .dec-num
              color #fff
      tr
        th:first-of-type, td:first-of-type
          border-left 0
          .ivu-table-cell
            padding-left 20px
    >>> .dec-clamp
      max-height 40px
      line-height 20px
      ellipsisClamp2()
      a
        color #FA5A00 !important
        &:after
          content ''
          width 4px
          height 4px
          border-right 1px solid #FA5A00
          border-bottom 1px solid #FA5A00
          display inline-block
          transform rotateZ(-45deg)
          margin-bottom 2px
          margin-left 5px
    >>> .ivu-table-row-hover
      .dec-clamp
        max-height 120px
        -webkit-line-clamp 6
    .toplist
      >>> .ivu-table
        table
          border 1px solid #DAB693
        th
          background linear-gradient(0deg, #3D4575 0%, #292D4D 100%)
          color #fff
        td
          .dec-num
            color #DAB693 !important
          .dec-num-1, .dec-num-2, .dec-num-3
            font-size 0
            line-height 1
            &:before
              content ''
              background-image url('~pic/tabletop1.png')
              width 21px
              height 24px
              display inline-block
              background-size 100% 100%
          .dec-num-2
            &:before
              background-image url('~pic/tabletop2.png')
          .dec-num-3
            &:before
              background-image url('~pic/tabletop3.png')
        .ivu-table-row-hover
          td
            border-color #FFF2E0 !important
            background-color #FFF2E0 !important
            color #FA5A00
            .dec-num
              color #DAB693 !important
            a
              color #FA5A00
            &.num
              background-color #FFF2E0 !important
        .ivu-table-tbody
          .ivu-table-row:nth-of-type(even)
            background-color rgba(128, 144, 201, 0.2) !important
            td
              .dec-num
                color #DAB693
  .tip
    font-size 12px
    commonColor(#BCBDC1, #999999)
    margin-top 10px
.spa
  position absolute
  right 0
  bottom -3px
  width 18px
  height 18px
  .iconfont
    font-size 18px
    line-height 1
    position absolute
    right 0
    top 0
    commonColor(#CCCCCC, #CCCCCC)
    &:hover
      color #63bf61 !important
  & >>> .ivu-poptip
    position absolute
    width 18px
    height 18px
    .ivu-poptip-rel
      position absolute
      width 18px
      height 18px
      right 0
      top 0
      cursor pointer
    .ivu-poptip-popper
      transform translate(13px, 0)
      .ivu-poptip-inner
        border-radius 0
        .share_cnt
          padding 10px 20px 10px 10px
          .share_img
            width 80px
            height 80px
            float left
            background #f0f0f0
          p
            line-height 20px
            color #666
            float right
            margin-top 20px
            font-size 14px
</style>
